import {useCallback} from 'react';
import {toast} from 'sonner';
import {useGoogleOAuthCallbackMutation} from './useGoogleOAuthCallbackMutation';
import {useAuth} from 'hooks/auth/useAuth';

const postBroadcastMessage = (message: Record<string, Error | boolean>) => {
  const channel = new BroadcastChannel('oauth');
  channel.postMessage(message);
  channel.close();
};

export const useGoogleSignIn = () => {
  const {authenticate} = useAuth();

  const {mutate: oauthGoogleCallback} = useGoogleOAuthCallbackMutation({
    onSuccess: data => {
      authenticate({token: data.access_token});
      postBroadcastMessage({isLoginSuccessful: true});
      window.close();
    },
    onError: error => {
      postBroadcastMessage({isLoginError: true, error: error});
      window.close();
    },
  });

  const subscribeOAuthGoogleCompletion = useCallback(
    ({
      onSuccess,
      onError,
    }: {
      onSuccess?: () => void;
      onError?: (error: Error) => void;
    }) => {
      const channel = new BroadcastChannel('oauth');

      channel.onmessage = event => {
        const {isLoginSuccessful, isLoginError, error} = event.data;
        if (isLoginSuccessful) {
          onSuccess?.();
        }
        if (isLoginError) {
          console.error(error);
          toast.error(
            'Authentication failed: Unable to sign in with Google. Please try again.',
          );
          onError?.(error);
        }
        channel.close();
      };

      return {
        unsubscribe: () => channel.close(),
      };
    },
    [],
  );

  return {
    oauthGoogleCallback,
    subscribeOAuthGoogleCompletion,
  };
};
